//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN - COMMON
export const POST_JWT_LOGIN = "/astro-users/authenticate"

export const POST_JWT_SIGNUP = "/astro-users/signup"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"

//TASKS
export const GET_TASKS = "/tasks"

//USERS
export const GET_USERS = "/users"
export const ADD_USER = "/users"
export const EDIT_USER = "/users"
export const DELETE_USER = "/users"
export const RESET_PWD = "/users"
export const CHANGE_PWD = "/users"
export const GET_USER_PROFILE = "/profile"

// AUDITS
export const GET_AUDITS = "/audits"

//GROUP AUDITS TESTING
export const GET_GROUP_AUDITS = "/audits"

export const POST_REGISTER_USER = "/astro-users"

export const POST_BIRTH_DETAILS = "/astro-users/birthChart"

export const GET_CAPTCHA = "/captacha"

export const GET_BIRTH_CHART_LIST = "/astro-users/birthChart"

export const GET_BIRTH_CHART = "/astro-users/birthChart"

export const GET_PLACES = "/places"

export const GET_PLACES_API_TOKEN = "/places/token"

export const ACTIVATE_USER = "/astro-users/activateUser"

export const ASTRO_USER_PROFILE = "/astro-users/profile"

// Product Admin

export const PRODUCT_ADMIN_LOGIN = "/astro-users/authenticate"

export const PRODUCT_ADMIN_PROFILE = "/product/profile"

export const GET_USER_BIRTH_CHART_LIST = "/product/userBirthChartList"

export const GET_BIRTH_CHART_PDF = "/product/birthChart/PDF"

export const GET_BIRTH_CHART_REPORT = "/product/birthChartReport"

export const GET_BIRTH_CHART_FOR_PRODUCT_ADMIN = "/product/birthChart"

// Product Admin - Reports
export const REPORT_UPLOAD = "/product/planetPositionReport"

// Product Admin - User Management
export const ASTRO_KEY = "/product/astroUsers"

// Group
export const GRP_REPORT = "/group/report"
export const GET_GRP_REPORT = "/group/report"
export const POST_GRP_BIRTH_DETAILS = "/group/birth-details"

export const GET_GRP_REPORT_FOR_GROUP_ADMIN = "/group/group-admin/report"

export const GET_GRP_REPORT_FOR_BRANCH_ADMIN = "/group/branch-admin/report"

export const GET_GRP_BRANCHES = "/group/branches"

export const GET_GRP_GROUP_USER = "/group/group-users"

export const GET_GRP_BRANCHES_AUTOSUGGEST = "/group/admin/branches"

export const GET_GRP_GROUP_USER_AUTOSUGGEST = "/group/admin/group-users"

export const GET_GRP_GROUP_MASTERS_AUTOSUGGEST = "group/admin/group-masters"

export const GET_GRP_USER_PROFILE = "/group/profile"

export const GET_ORGANIZATION_PROFILE = "/group/group-profile"

export const GET_USER_DASHBOARD = "/group/userdashboard"

export const GET_REPORT_DASHBOARD = "/group/reportdashboard"

export const GET_INVOICE = "/payments/invoice"

export const MAKE_PAYMENT = "/paymenturl"

export const GROUP_REPORT_CREATE = "/report/application"

export const GROUP_FETCH = "/report/fetchGroup"




